import axiosInstance from './util/auth_util'

const OrderService = {
    // 用户获取订单
    async getOrders(params){
        try {
            const response = await axiosInstance.get(`/orders`,{
                params: params 
            })
            return response.data
        }catch(error){
            throw error.response?.data || error.message
        }
    },

    // 管理员获取用户订单
    async getAllOreders(params){
        try {
            const response = await axiosInstance.get(`/orders/manage`, { params })
            return response.data
        }catch(error){
            throw error.response?.data || error.message
        }
    },

    // 新增订单
    async createFinalOrder(order){
        try {
            const response = await axiosInstance.post(`/orders/add`,order)
            return response.data
        }catch(error){
            throw error.response?.data || error.message
        }
    },

    // 手動新增訂單（管理後台）
    async createManualOrder(order){
        try {
            const response = await axiosInstance.post(`/orders/manual_add`, order)
            return response.data
        }catch(error){
            throw error.response?.data || error.message
        }
    },

    // 更新訂單物流
    async updateOrderLogistics(id, params={}){
        try {
            const response = await axiosInstance.put(`/orders/logistics/${id}`, params)
            return response.data 
        }catch(error){
            throw error.response?.data || error.message
        }
    },

    async cancelUserOrder(orderId){
        try {
            const response = await axiosInstance.delete(`/orders/del/${orderId}`)
            return response.data
        }catch(error){
            console.log("error", error)
            throw error.response?.data || error.message
        }
    },
}

export default OrderService